module.exports = __webpack_public_path__ + "fontawesome-webfont.acf3dcb7ff752b5296ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/newtheme/fa/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 482
// module chunks = 2